// CustoMeeオプションが含まれている商品でのみ読み込む

(function() {
    const CUSTOM_ORDER_OPTION_NAME = 'カスタムオーダー';
    const CUSTOMEE = {
        BASE_URL: 'https://app.customee.net/5ac9d2c0ae89006f79e589a43683ec3d?category=',
        CATEGORY: {
            '/products/hamic-miels': 'Hamic MIELS nico',
            '/products/case-hamic-miels': 'Hamic MIELS / MIELS nico 専用 iFace',
            '/products/rental-hamic-miels': 'Hamic MIELS nico シェアプラン'
        }
    };
    const ERROR_MESSAGES = {
        elementNotFound: '指定した要素が見つかりません。'
    };
    // セレクトボックス, 通常カートボタン, CustoMee起動ボタン, 規約エリア
    const selectElement = document.querySelector('.single-option-selector');
    const cartButton = document.querySelector('.product-form__cart-submit');
    const customeeDiv = document.querySelector('.js-customee-area');
    const customeeButton = document.querySelector('.js-customee-create');
    const productTerms = document.querySelector('.Store__productTerms');
    
    if (!selectElement || !cartButton || !customeeDiv) {
        console.warn(ERROR_MESSAGES.elementNotFound);
    }

    // 商品カテゴリに応じたCustoMeeのURLをセットする
    function setCustomeeUrl() {
        for (const pathname in CUSTOMEE.CATEGORY) {
            if (window.location.pathname.includes(pathname)) {
                customeeButton.href = CUSTOMEE.BASE_URL + CUSTOMEE.CATEGORY[pathname];
                break;
            } else {
                customeeButton.href = CUSTOMEE.BASE_URL;
            }
        }
    }

    function toggleDisplay(element, shouldShow) {
        if (!element) return;
        element.style.display = shouldShow ? 'block' : 'none';
    }

    // CustoMee導線有効化
    function enableCustoMee() {
        toggleDisplay(cartButton, false);
        toggleDisplay(productTerms, false);
        toggleDisplay(customeeDiv, true);
    }

    // CustoMee導線無効化
    function disableCustoMee() {
        toggleDisplay(cartButton, true);
        toggleDisplay(productTerms, true);
        toggleDisplay(customeeDiv, false);
    }

    // select要素の現在の値に基づいてカートとCustoMeeボタンを表示または非表示
    function switchCartButton() {
        if (selectElement.value.includes(CUSTOM_ORDER_OPTION_NAME)) {
            enableCustoMee();
        } else {
            disableCustoMee();
        }
    }

    setCustomeeUrl();
    
    switchCartButton();
    
    // select要素の変更を検出し、switchCartButtonを実行
    selectElement.addEventListener('change', switchCartButton);
})();